import { AccountI } from '@/types/account';
import { MetaEntity, PageVisibilityStatus } from '@/types/meta';

export interface CourseEntity {
  _id?: string;
  meta?: MetaEntity | string;
  title: string;
  des: string;
  lang: string;
  cover?: string;
  previewVideoUrl?: string;
  coverAlt?: string;
  author?: string;
  body?: string;
  limitFreeUsage?: number;
  price: CoursePriceEntity;
  discount?: CourseDiscountEntity | null;
  mainProps?: string[];
  extraProps?: string[];
  status?: PageVisibilityStatus;
  chapters?: ChaptersEntity[];
  contentTitle?: string;
  registeredMembers?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface ChapterPartEntity {
  title: string;
  des?: string;
  url?: string;
  fileType?: 'video' | 'image' | 'dl';
  lock?: CourseContentLockEnum;
}

export interface ChaptersEntity {
  title?: string;
  parts: ChapterPartEntity[];
}

export enum CourseContentLockEnum {
  free = 'free',
  registerRequired = 'register-required',
  purchase = 'purchase',
}

export interface CoursePriceEntity {
  baseCurrency: CurrencyEnum;
  value: number;
  convertedPrices?: Record<string, number>;
}

export interface CourseDiscountEntity {
  method: 'percentage' | 'fixed';
  value: number;
  expirationDate?: Date;
}

export interface CourseMemberEntity {
  course: CourseEntity | string;
  account: AccountI | string;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
  _id: string;
}

export enum CurrencyEnum {
  IRT = 'IRT',
  BTC = 'BTC',
  USD = 'USD',
  USDT = 'USDT'
}